const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const ago = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return iso(d); };

export const PRESETS = [
  { id: "hoje", label: "Hoje", range: () => [ago(0), ago(0)] },
  { id: "ontem", label: "Ontem", range: () => [ago(1), ago(1)] },
  { id: "7d", label: "Últimos 7 dias", range: () => [ago(6), ago(0)] },
  { id: "30d", label: "Últimos 30 dias", range: () => [ago(29), ago(0)] },
  { id: "custom", label: "Personalizado" },
];

export const fmtDay = (d) => d.split("-").reverse().join("/");

export const PeriodPicker = ({ preset, setPreset, custom, setCustom }) => (
  <div className="flex flex-col gap-2 sm:items-end">
    <div className="flex flex-wrap gap-1.5" role="group" aria-label="Período">
      {PRESETS.map((p) => (
        <button key={p.id} data-testid={`period-${p.id}`} onClick={() => setPreset(p.id)}
          className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${preset === p.id ? "bg-zap-deep text-white" : "bg-zap-mist hover:bg-zap-line"}`}>
          {p.label}
        </button>
      ))}
    </div>
    {preset === "custom" && (
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <label className="flex items-center gap-1.5">De
          <input type="date" data-testid="period-start" value={custom[0]} max={custom[1] || ago(0)}
            onChange={(e) => setCustom([e.target.value, custom[1]])} className="h-9 rounded-md border border-zap-line px-2" />
        </label>
        <label className="flex items-center gap-1.5">até
          <input type="date" data-testid="period-end" value={custom[1]} min={custom[0]} max={ago(0)}
            onChange={(e) => setCustom([custom[0], e.target.value])} className="h-9 rounded-md border border-zap-line px-2" />
        </label>
      </div>
    )}
  </div>
);

export const defaultCustom = () => [ago(29), ago(0)];
